import { Box, Grid, Stack, Typography } from '@mui/joy';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Modal from '../../components/modal';
import { useUser } from '../../hooks/useUser';
import ActivityScroller from './activityScroller';
import { UpcomingEvents } from './upcomingEvents';

function ActivityFeed() {
  const location = useLocation();
  const userQuery = useUser();
  const [welcomeModalOpen, setWelcomeModalOpen] = useState(
    !!new URLSearchParams(location.search).get('firstTime')
  );

  const title = userQuery.isSuccess
    ? `${userQuery.data?.firstName}'s tijdlijn`
    : 'Activiteiten';

  return (
    <>
      <Modal
        title="Welkom! 🎉"
        isOpen={welcomeModalOpen}
        setOpen={setWelcomeModalOpen}
        showCancel={false}
        onConfirm={async () => {
          setWelcomeModalOpen(false);
          return true;
        }}
      >
        <Typography>
          Welkom bij ScConnect. Leuk dat je gebruik maakt van ons kanaal!
        </Typography>
      </Modal>

      {/* Content */}
      <Grid
        container
        sx={{
          minHeight: '100%',
          paddingTop: '1rem',
          paddingBottom: '2rem',
        }}
      >
        <Grid
          xs={12}
          lg={0}
          sx={{
            display: {
              xs: 'block',
              lg: 'none',
            },
          }}
        >
          <Box marginBottom={'2rem'} paddingX={'1rem'}>
            <UpcomingEvents onlyShowFirstOnMobile={true} />
          </Box>
        </Grid>
        <Grid xs={12} lg={9}>
          <Box
            sx={{
              paddingX: {
                xs: '1rem',
                lg: '3rem',
                xl: '5rem',
              },
            }}
          >
            <Stack spacing={3}>
              <Typography level="h1">{title}</Typography>
              <ActivityScroller />
            </Stack>
          </Box>
        </Grid>

        {/* Right column */}
        <Grid
          xs={0}
          lg={3}
          paddingX={'1rem'}
          sx={{
            display: {
              xs: 'none',
              lg: 'block',
            },
          }}
        >
          <Grid xs={12} lg={3} sx={{}}></Grid>
          <Box marginTop={'4.5rem'}>
            <UpcomingEvents onlyShowFirstOnMobile={true} />
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

export default ActivityFeed;
